import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.js';
import routes from "./routes";

window.bootstrap = bootstrap;

function getPageName() {
    const main = $('#main');
    const classList = main.attr('class');
    let result = '';

    classList.split(' ').some(className => {
        if (className.startsWith('page')) {
            result = className;

            return true;
        }
    })

    return result;
}

function dispatchRoute() {
    const pageName = getPageName();

    routes.some(route => {
        let routeKey = Object.keys(route)[0];

        if (routeKey === pageName) {
            route[routeKey].init();

            return true;
        }
    })
}

$(function() {
    dispatchRoute();
});
